import React, { useState } from "react";
import { Form, Input, Button, Checkbox, message, Typography } from "antd";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { SendMail } from "../request/apiRquest";
import "./getInTouch.css";

const { Title } = Typography;

const GetInTouch = ({ onClose }) => {
  const [form] = Form.useForm();
  const [phone, setPhone] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    console.log("Received values from form:", values);

    if (!phone) {
      message.error("Phone number is required");
      return;
    }

    const { name, email, message: userMessage } = values;

    if (!name || !email || !userMessage) {
      message.error("Please fill all required fields.");
      return;
    }

    const payload = {
      FromName: name,
      FromEmail: email,
      ContactNo: phone,
      Message: userMessage,
      Language: navigator.language || "EN",
    };

    console.log("Payload to backend:", payload);

    try {
      setLoading(true);
      const response = await SendMail(payload);

      if (response?.success) {
        message.success("Enquiry sent successfully!");
        form.resetFields();
        setPhone("");
        setAcceptTerms(false);
        if (onClose) onClose();
      } else {
        message.error(response?.message || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      message.error("Error while sending form.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
  style={{
    width: "100%",
   
    padding: "20px",
    //overflowX: "auto", // allow horizontal scroll if needed
    boxSizing: "border-box",
    //position:"",
    zIndex: "9999",
  }}
>
  <div
    style={{
      maxWidth: "500px",
      margin: " auto",
      paddingTop:"20px",
     
    }}
  >

      <Title level={3}>Contact us to find your perfect property</Title>

      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Full Name"
          name="name"
          rules={[{ required: true, message: "Please enter your name" }]}
        >
          <Input placeholder="Your name" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input placeholder="you@company.com" />
        </Form.Item>

        <Form.Item label="Phone number" required>
          <PhoneInput
            country={'us'}
            value={phone}
            onChange={setPhone}
            inputProps={{ name: 'phone', required: true }}
            inputStyle={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          label="Message"
          name="message"
          rules={[{ required: true, message: "Please enter your message" }]}
        >
          <Input.TextArea rows={1} />
        </Form.Item>

        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject("Please accept terms and conditions"),
            },
          ]}
        >
          <Checkbox
            className="custom-checkbox"
            onChange={(e) => setAcceptTerms(e.target.checked)}
          >
            By accepting and providing my personal information I am consenting to TrinestSky Group{" "}
            <a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>, the applicable data protection laws and{" "}
            <a href="/terms" target="_blank" rel="noreferrer">Terms of Use</a>.
          </Checkbox>
        </Form.Item>

        <Form.Item name="newsletter" valuePropName="checked">
          <Checkbox className="custom-checkbox">
            I agree to receive information about offers, deals and services from this website (optional).
          </Checkbox>
        </Form.Item>

        <Button
          style={{ backgroundColor: "#FDA94F" }}
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={!acceptTerms}
          block
          className="custom-submit-btn"
        >
          Enquire now
        </Button>
      </Form>
        </div>
    </div>
  );
};

export default GetInTouch;
